var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsells"},_vm._l((_vm.upsellItems),function(text,index){return _c('div',{key:`u${index}`,staticClass:"upsells__upsell"},[(!_vm.hideIcon)?_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{staticClass:"has-text-success",attrs:{"icon":['fa', 'check']}})],1):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(text)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }